import { Component } from 'opus-angular-seed-core';
import template from './template.html';
@Component({
    template
})

export default class {
    constructor ($state, $translate, $scope, lodash, AuthService, TokenService, PrivilegeService, ModalService,
                 SiteService, UserResource, ngProgressFactory, AuthResource, COMPANY_ADMIN_LANGUAGE_ENUM, ReportService) {
        this.$state = $state;
        this.$translate = $translate;
        this.lodash = lodash;
        this.AuthService = AuthService;
        this.TokenService = TokenService;
        this.SiteService = SiteService;
        this.PrivilegeService = PrivilegeService;
        this.ModalService = ModalService;
        this.UserResource = UserResource;
        this.AuthResource = AuthResource;
        this.COMPANY_ADMIN_LANGUAGE_ENUM = COMPANY_ADMIN_LANGUAGE_ENUM;
        this.ReportService = ReportService;
        this.loader = ngProgressFactory.createInstance();

        $scope.$on('token:refresh:complete', () => {
            this.initSites();
            // the cookie holds a token of its own - a tab left open long
            // enough would otherwise carry an expired one to the portal
            this.initAnalytics();
        });
    }

    $onInit () {
        this.langOpen = false;
        this.initSites();
        this.activeSiteId = this.TokenService.getActiveSiteId();
        this.firstReportState = this.getFirstReportState();
        this.initAnalytics();
    }

    initSites () {
        this.sites = this.lodash.map(this.SiteService.sites, value => {
            return { id: parseInt(value.id, 10), name: value.name };
        });
    }

    openTermsAndConditions () {
        this.ModalService.open({
            template: '<modals-account-terms-and-conditions class="wrapper" close="vm.close()" company-terms="vm.terms"/>',
            resolve: {
                company (CompanyResource) {
                    return CompanyResource.terms().$promise;
                }
            },
            controller ($uibModalInstance, company) {
                this.terms = company.terms;
                this.$uibModalInstance = $uibModalInstance;
                this.close = () => {
                    this.$uibModalInstance.close();
                };
            }
        });
    }

    openChangeLog () {
        this.ModalService.open({
            template: '<modals-changelog class="wrapper" close="vm.close"/>',
            size: 'large',
            resolve: {},
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.close = () => {
                    this.$uibModalInstance.close();
                };
            }
        });
    }

    getSupportButtonUrl () {
        if (this.TokenService.getActiveLanguage() === this.COMPANY_ADMIN_LANGUAGE_ENUM.KEYS.EN) {
            return 'https://support.coursy.io/docs/coursy-in-short/';
        }
        return 'https://support.coursy.io/et/docs/coursy-kasutusjuhend/';
    }

    changeActiveSite () {
        this.AuthResource
            .selectSite({}, { siteId: this.activeSiteId })
            .$promise
            .then(() => {
                window.location.reload(true);
            })
            .catch((response) => {
                this.toastr.error(response.data[0].message);
            });
    }

    toggleLang () {
        this.langOpen = !this.langOpen;
    }

    isFeedbackMenuActive () {
        return this.$state.includes('authorized.review') ||
            this.$state.includes('authorized.evaluation') ||
            this.$state.includes('authorized.survey')
        ;
    }

    switchAdminLanguage (code) {
        this.loader.start();
        this.UserResource
            .switchAdminLanguage({ adminLanguage: code })
            .$promise
            .then(() => {
                this.loader.complete();
                window.location.reload(true);
            });
    }

    getFirstReportState () {
        return this.ReportService.getFirstReportState();
    }

    /**
     * The portal picks the token up from a cookie, so the cookie has to be in
     * place before the navigation starts. Setting it on click would leave the
     * menu item a dead <a> - right click, middle click and "open in new tab"
     * never run the handler.
     */
    initAnalytics () {
        const url = SEED_CORE.ENV.ANALYTICS_PORTAL_URL;

        if (!url || !this.TokenService.isAnalyticsModuleEnabled() || !this.PrivilegeService.canViewAnalytics()) {
            return;
        }

        this.analyticsUrl = url;
        this.AuthResource
            .shortToken()
            .$promise
            .then(({ token }) => this.setAnalyticsCookies(token));
    }

    setAnalyticsCookies (token) {
        const locale = this.TokenService.getActiveLanguage(true);
        const isCoursyDomain = window.location.hostname.endsWith('.coursy.io');
        const envAttrs = isCoursyDomain ? ' domain=.coursy.io; Secure;' : '';

        document.cookie = `coursy_jwt=${token}; path=/; SameSite=Lax;${envAttrs}`;
        document.cookie = `NEXT_LOCALE=${locale}; path=/; SameSite=Lax;${envAttrs}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/sidebar/index.js